import { PropsWithChildren } from 'react';

import { NoJSLink } from 'Components/NoJSLink/NoJSLink';

import styles from './FilterLink.module.css';

export const FilterLink = ({
  link,
  children,
}: PropsWithChildren<{
  link: {
    href: string;
    nofollow: boolean;
  } | null;
}>) => {
  return link ? (
    // The anchor is here for SEO and progressive enhancement purposes.
    <NoJSLink
      href={link.href}
      className={styles.filterLink}
      rel={link.nofollow ? 'nofollow' : undefined}
    >
      {children}
    </NoJSLink>
  ) : (
    children
  );
};
